<template>
  <div class="weather-graph">
    <div class="row">
      <div class="col-12 col-lg-8">
        <div class="weather-graph-buttons">
          <div class="weather-graph-buttons_wr">
            <!--формат даты без времени с 2020-09-16 по 2020-09-25-->
            <flat-pickr
              v-model="dataTime"
              :config="config"
              class="form-control"
              placeholder="Выберите дату"
              name="date" ></flat-pickr>
            <div @click="fetchData()"  :class="loading ? 'statistics-select__button loading' : 'statistics-select__button'">применить <i class="load-style"></i></div>
          </div>
        </div>
        <div class="weather-graph-start">
          <highcharts :key="componentKey" :options="chartOptions" :constructor-type="'stockChart'"></highcharts>
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="weather-photo-date">{{photo.date}}</div>
        <div class="weather-photo">
          <img :src="photo.img" @click="openModalSingleGallery" :alt="photo.date">
        </div>
        <div class="weather-photo-link"  @click="openGallery">Все фото</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from 'highcharts-vue'
import stockInit from 'highcharts/modules/stock'
import Highcharts from 'highcharts'
import graphConfigs from '@/components/graphConfigs'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import moment from 'moment'
import StatisticsAPI from '@/api/statistics'
import axios from 'axios'
import Meteo from '@/helpers/Meteo'

stockInit(Highcharts)

export default {
  name: 'Graph',
  mixins: [graphConfigs],
  components: {
    flatPickr,
    'highcharts': Chart
  },
  props: {
    station: {
      type: Object,
      required: true
    }
  },
  created () {
    this.meteo = new Meteo(this.station)
    this.loading = true
    this.fetchData().then(() => {
      this.loading = false
    })
    this.fetchLastPhoto()
  },
  methods: {
    forceRerender () {
      this.componentKey += 1
    },
    fetchLastPhoto () {
      axios.get('https://tel.pvcontrol.solar/pvcontrol/api/snapshot?stationId=' + this.$route.params.id)
        .then((r) => {
          this.photo.img = r.data.filename
          this.photo.date = moment(r.data.date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
        })
    },
    async fetchData () {
      let _this = this
      let Parametrs = {}
      let meteoStation = [
        _this.meteo.getAirTemperature(),
        _this.meteo.getWindSpeed()
      ]
      Parametrs[_this.station.meteo.solar_horiz] = [_this.meteo.getInsolation()]
      Parametrs[_this.station.meteo.solar_plane] = [_this.meteo.getInsolation()]
      Parametrs[_this.station.meteo.meteo_station] = meteoStation
      Parametrs[_this.station.meteo.term] = [_this.station.meteo.temp_param.top]

      let from, to

      if (this.dataTime === null) {
        from = moment(this.from).format('YYYY-MM-DD HH:mm:ss')
        to = _this.to
      } else {
        let match = this.dataTime.match(/(\d\d\d\d-\d\d-\d\d)\sto\s(\d\d\d\d-\d\d-\d\d)/)
        from = match[1] + ' 00:00:00'
        to = match[2] + ' 23:59:59'
      }

      if ((moment(to).valueOf() - moment(from).valueOf()) / 86400000 <= 31) {
        this.loadPhotos(this.$route.params.id, from, to)

        let graphData = await StatisticsAPI.fetchData(this.$route.params.id, {
          'from': from,
          'to': to,
          'devices': Parametrs,
          'each': null
        })

        _this.chartOptions.series = []

        Object.keys(graphData.data).forEach((key) => {
          let name = key.split('_')
          if (name.includes(String(_this.station.meteo.solar_horiz))) {
            _this.chartOptions.series.push({
              data: graphData.data[key],
              name: 'Solar horizont',
              yAxis: 1
            })
          } else if (name.includes(String(_this.station.meteo.solar_plane))) {
            _this.chartOptions.series.push({
              data: graphData.data[key],
              name: 'Solar plane panel',
              yAxis: 1
            })
          } else if (name.includes(String(_this.station.meteo.term))) {
            _this.chartOptions.series.push({
              data: graphData.data[key],
              name: 'Temperature panel',
              yAxis: 2
            })
          } else if (name.includes('temperature')) {
            _this.chartOptions.series.push({
              data: graphData.data[key],
              name: 'Air temperature ',
              yAxis: 2
            })
          } else if (name.includes('wind')) {
            _this.chartOptions.series.push({
              data: graphData.data[key],
              name: 'Wind speed',
              yAxis: 0
            })
          }
        })
        this.forceRerender()
      } else {
        alert('Значение даты не может превышать 31 день')
      }

      return true
    },
    loadPhotos (id, from, to) {
      let _this = this

      axios.get('https://tel.pvcontrol.solar/pvcontrol/api/period', {
        params: {
          'stationId': id,
          'startDate': from,
          'endDate': to
        }
      }).then((r) => {
        let batches = []; let i = 0; let batch = null

        r.data.forEach((val) => {
          if ((i % 100) === 0) {
            if (batch !== null) {
              batch.to = val.date
              batches.push(batch)
            } else {
              batch = {
                'from': val.date,
                'photos': []
              }
            }

            batch = {
              'from': val.date,
              'photos': []
            }
          }

          let img = new Image()
          img.src = val.filename

          batch.photos.push(val)
          i++
        })

        if ((batch !== null) && (batch.photos.length > 0)) {
          batch.to = batch.photos[batch.photos.length - 1].date
          batches.push(batch)
        }

        _this.photoBatches = batches
      })
    },
    selectPhoto (date) {
      let notFound = true; let _this = this

      this.photoBatches.forEach((batch) => {
        if ((date > batch.from) && (date < batch.to)) {
          batch.photos.forEach((val) => {
            if ((date < val.date) && notFound) {
              _this.photo.img = val.filename
              _this.photo.date = val.date
              notFound = false
            }
          })
        }
      })
    },
    openModalSingleGallery (event) {
      removeModal()
      function removeModal () {
        let removeElements = document.getElementsByClassName('modal-single-photo')
        for (let i = 0; i < removeElements.length; i++) {
          removeElements[i].remove()
        }
      }

      let beforeWidth = document.documentElement.clientWidth

      let img = new Image()
      img.src = event.target.getAttribute('src')

      let div = document.createElement('div')
      div.className = 'modal-single-photo'
      div.innerHTML = "<div class='modal-single-photo__close'></div><div class='modal-single-photo__img'><div class='modal-single-photo__img_img'><div class='modal-single-photo__img_close'></div></div></div>"
      document.body.append(div)
      document.getElementsByClassName('modal-single-photo__img_img')[0].append(img)
      document.body.classList.add('body-modal-photo')
      let afterWidth = document.documentElement.clientWidth

      if (beforeWidth < afterWidth) {
        let newWidth = afterWidth - beforeWidth
        document.body.style.paddingRight = newWidth + 'px'
        document.getElementById('header_').style.paddingRight = newWidth + 'px'
        document.getElementsByClassName('modal-single-photo__close')[0].style.right = newWidth + 'px'
        document.getElementsByClassName('modal-single-photo__img_close')[0].style.right = newWidth + 'px'
      }

      function removeModalStyle () {
        removeModal()
        document.body.classList.remove('body-modal-photo')
        document.body.style.paddingRight = ''
        document.getElementById('header_').style.paddingRight = ''
      }

      document.getElementsByClassName('modal-single-photo__img')[0].addEventListener('click', function (e) {
        let div = document.getElementsByClassName('modal-single-photo__img')[0]
        if (div === e.target) {
          removeModalStyle()
        }
      })

      document.getElementsByClassName('modal-single-photo__close')[0].addEventListener('click', function () {
        removeModalStyle()
      })
      document.getElementsByClassName('modal-single-photo__img_close')[0].addEventListener('click', function () {
        removeModalStyle()
      })
    },
    openGallery () {
      this.$router.push({
        name: 'gallery',
        id: this.$route.params.id
      })
    }
  },
  data () {
    const _this = this

    return {
      from: moment().valueOf() - 48 * 60 * 60000,
      to: moment().format('YYYY-MM-DD HH:mm:ss'),
      meteo: null,
      loading: false,
      photo: {
        img: '/img/station-foto.cb53fef9.jpg',
        date: '12 сентября 2020, 12:30:24'
      },
      config: {
        dateFormat: 'Y-m-d',
        mode: 'range'
      },
      dataTime: null,
      photoBatches: null,
      componentKey: 0,
      chartOptions: {
        chart: {
          marginLeft: 80
        },
        tooltip: {
          formatter: function (tooltip) {
            _this.selectPhoto(moment(this.x).utc().format('YYYY-MM-DD HH:mm:ss'))
            return tooltip.defaultFormatter.call(this, tooltip)
          }
        },
        yAxis: [{
          title: {
            text: 'Wind Speed',
            style: {
              color: '#fff'
            }
          },
          gridLineColor: '#595c5e',
          labels: {
            distance: 0,
            format: '{value} m/s',
            style: {
              color: '#fff',
              style: {
                color: '#fff'
              }
            }
          },
          opposite: false
        }, {
          title: {
            text: 'Insolation',
            style: {
              color: '#fff'
            }
          },
          opposite: true,
          gridLineColor: '#595c5e',
          labels: {
            format: '{value} W/m2',
            style: {
              color: '#fff'
            }
          }
        },
        {
          title: {
            text: 'Temperature',
            style: {
              color: '#fff'
            }
          },
          opposite: true,
          gridLineColor: '#595c5e',
          labels: {
            format: '{value} C',
            style: {
              color: '#fff'
            }
          }
        }],
        series: [],
        rangeSelector: {
          enabled: false
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
